// src/components/Footer.jsx

import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import '../styles/Footer.css';
import styles from '../styles/Footer.module.css' 
import logo from '../assets/logo_orange.svg';
import logoSchoen from '../assets/fahrschule_schoen_weiss.png';

const Footer = () => {
  const location = useLocation();
  const { pathname } = location;

  return (
    <footer className={styles.footer}>
      <div className={styles['footer-container']}>
        
        {/* Логотип и описание / Logo und Beschreibung */}
        <div className={styles['footer-section']}>
          <img src={logo} alt="Logo" className={styles['footer-logo']} />
          <p className={styles['footer-description']}>
            Fahrschule ORANGEdrivers
          </p>
          <div className={styles['footer-socials']}>
            <a href="https://www.facebook.com/orangedrivers.at/" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
              <i className="fab fa-facebook-f"></i>
            </a>
            <a href="https://www.instagram.com/orangedrivers.at/" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
              <i className="fab fa-instagram"></i>
            </a>
          </div>
        </div>
        
        {/* Ссылки / Links */}
        <div className={styles['footer-section']}>
          <h3>Navigation</h3>
          <ul className={styles['footer-links']}>
            <li>
              { pathname === '/' ? (
                <Link to="/" onClick={() => window.scrollTo(0, 0)}>Home</Link>
              ) : (
                <Link to="/">Home</Link>
              )}
            </li>
            <li><Link to="/impressum">Impressum</Link></li>
            <li><Link to="/datenschutz">Datenschutz</Link></li>
            <li><Link to="/agb">AGB</Link></li>
            <li><Link to="/widerrufsbelehrung">Widerrufsbelehrung</Link></li>
            {/* <li><Link to="/contact">Kontakt</Link></li> */}
          </ul>
          {/* <div className="calendly-inline-widget" data-url="https://calendly.com/office-orange-drivers/beratungsgesprach-baden?hide_event_type_details=1" style={{minWidth: 320 + 'px', height: 700 + 'px'}}></div>
<script type="text/javascript" src="https://assets.calendly.com/assets/external/widget.js" async></script> */}
        </div>
        
        {/* Социальные сети / Soziale Netzwerke */}
        {/* <div className={styles['footer-section']}>
          <h3>Social Networks</h3>
          <div className={styles['footer-socials']}>
            <a href="https://www.facebook.com/orangedrivers.at/" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
              <i className="fab fa-facebook-f"></i>
            </a>
            <a href="https://www.instagram.com/orangedrivers.at/" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
              <i className="fab fa-instagram"></i>
            </a>
          </div>
        </div> */}
        
        {/* Контактная информация / Kontaktinformationen */}
        <div className={styles['footer-section']}>
          <h3>Kontakt</h3>
          <p>Email: <a href="mailto:office@orange-drivers.at">office@orange-drivers.at</a></p>
          <p>Telefon: <a href="tel:+43225287630">+43 2252 87630</a></p>
          <p>Braitnerstrasse 42,<br />
          2500 Baden</p>
        </div>
        
      </div>
      
      {/* Нижняя часть футера / Unterer Teil des Footers */}
      <div className={styles['footer-bottom']}>
        <p>&copy; {new Date().getFullYear()} z-works. All rights reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;
